import { injectScript } from "./loader";


// KEY= widgetId,  VALUE= vuex
export const shareUtilsGlobal = {};
const shareUtilsMap = new Map();


export async function initShareUtils(utilObj, options) {

    let sharePromiseList = [];
    for (const [key, value] of Object.entries(utilObj)) {
        // 性能待优化
        if (shareUtilsMap.has(key)) {
            sharePromiseList.push(shareUtilsMap.get(key))
        } else {
            shareUtilsMap.set(key, loadShareWidget(key, value, options));
            sharePromiseList.push(shareUtilsMap.get(key))
        }
    }
    return Promise.all(sharePromiseList);
}

function loadShareWidget(utilKey, utilScript, options) {
    return injectScript(utilScript, options).then((utilEntry) => {
        if (utilEntry && utilEntry.default) {
            if (typeof window !== 'undefined' && window.Vuex) {
                shareUtilsGlobal[utilKey] = new Vuex.Store(utilEntry.default);
            } else {
                console.error('[widget-loader]: 请页面加载 Vuex')
            }
        }
    })
}